<template>
  <div class="thanksgiving">
    <bim-text type="desc" bold class="thanksgiving__title mb-9">Благодарственные письма</bim-text>
    <div v-swiper:swiperModel="swiperOption">
      <div class="swiper-wrapper">
        <div class="swiper-slide" v-for="slide in sliderData" :key="slide">
          <div @click="openModalImages(slide)" class="swiper-wrapper__slide-wrapper">
            <img class="swiper-slide__image" :src="slide" alt="">
          </div>
        </div>
      </div>
    </div>
    <bim-button
      text-color="#4d4d4d"
      color="white"
      icon-size="18"
      rounded
      icon="icon-arrow-left22"
      id="content-button-prev"
      class="slider-arrows slider-arrows--prev swiper-button-prev"
    />
    <bim-button
      text-color="#4d4d4d"
      color="white"
      icon-size="18"
      rounded
      icon="icon-arrow-right22"
      id="content-button-next"
      class="slider-arrows slider-arrows--next swiper-button-next"
    />
    <bimPopup
      title=""
      v-model="imagePopup.show"
      :width="ww > 575 ? '60vw' : '90vw'"
      closeOnWrapper
    >
      <img alt="" :src="imagePopup.data" />
    </bimPopup>
  </div>
</template>

<script>
import bimPopup from "@bimlib/components/bimPopup"
import { directive } from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'

const letterPath = "/dist/assets/front_white/img/cases/letters"

export default {
  components: {
    bimPopup,
  },
  directives: {
    swiper: directive,
  },
  data() {
    return {
      imagePopup: {
        show: false,
        data: null
      },
      sliderData: [
        '148 Союз архитекторов_page-0001.jpg',
        '2019.12.30_Благодарность компании BIMLIB_VIESSMANN_page-0001.jpg',
        '2020.02.21_Благодарность Альтернатива фасадные системы_page-0001.jpg',
        '2020.11.13_Благодарность компании BIMLIB_РЗКК_page-0001.jpg',
        'Отзыв ДВР.jpeg',
        'Отзыв ЗАО Инженер.jpg',
        'отзыв от VEKA_page-0001.jpg',
        'отзыв Эко Док_page-0001.jpg',
        'Отзывы застройщиков_page-0001.jpg',
        'Отзывы застройщиков_page-0002.jpg',
        'Отзывы застройщиков_page-0003.jpg',
        'Отзывы застройщиков_page-0004.jpg',
        'Отзывы застройщиков_page-0005.jpg',
        'Отзывы застройщиков_page-0006.jpg',
        '14.jpg',
        '15.jpg',
        '16.jpg',
      ].map(d => `${letterPath}/${d}`),
      swiperOption: {
        navigation: {
          nextEl: '#content-button-next',
          prevEl: '#content-button-prev',
        },
        slidesPerView: 4,
        breakpoints: {
          1279: {
            slidesPerView: 4,
          },
          768: {
            slidesPerView: 3,
          },
          575: {
            slidesPerView: 2,
          },
          320: {
            slidesPerView: 1,
          },
        },
      },
    }
  },
  methods: {
    openModalImages(imageSrc) {
      this.imagePopup.data = imageSrc
      this.imagePopup.show = true
    },
  }
}
</script>

<style lang="scss" scoped>
@import './src/front_white/sass/components/settings';

.thanksgiving {
  position: relative;
  background-color: $white-color-100;
  width: 100%;
  padding: 24px;
  border-radius: 5px;

  .thanksgiving__title {
    text-transform: uppercase;
    text-align: center;
    line-height: 1.83;
    letter-spacing: 0.5px;
    color: $primary-color;
  }
}

.swiper-slide {
  .swiper-slide__image {
    cursor: pointer;
    max-width: 155px;
    max-height: 215px;
    object-fit: contain;
    object-position: center;
  }

  .swiper-wrapper__slide-wrapper {
    width: fit-content;
    margin: auto;
  }
}

.slider-arrows {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  z-index: 1;
  box-shadow : 0 5px 15px 0 rgba(0, 0, 0, 0.15) !important;

  i:before {
    color : $black-color !important;
  }

  &.swiper-button-disabled {
    display : none !important;
  }

  &.swiper-button-prev, &.swiper-button-next {
    &:after {
      content : ""
    }
    margin-top: 0 !important;
  }

  &.swiper-button-prev {
    left: 15px;
  }

  &.swiper-button-next {
    right: 15px
  }
}
</style>
